import { store } from 'stores/Store';
import styles from './SendTab.module.scss';

interface ISendTab {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSelect: (opt: string) => void;
}

const SendTab = ({isOpen, setIsOpen, onSelect}: ISendTab) => {

  return (
    <div style={{display: isOpen ? 'block' : 'none'}}>
    <div className={styles.optsWrapper}>
      <div style={{
        maxHeight: '300px',
        overflowY: 'auto'
      }}>
        <div className={styles.headerWrapper}>
          <p style={{fontSize: '16px', fontWeight: '700', textAlign: 'center'}}>How would you like to reach out?</p>
        </div>

        <button 
          className={styles.btn}
          onClick={() => onSelect('email')}
        >
          EMAIL
          <p className={styles.smallText}>{store.currentPractitioner?.email}</p>
        </button>
        <button
          className={styles.btn}
          onClick={() => onSelect('phone')}
        >
          CALL
          <p className={styles.smallText}>{store.currentPractitioner?.phone}</p>
        </button>
        {/*
        <button
          className={styles.btn}
          onClick={() => onSelect('website')}
        >
          WEBSITE
          <p className={styles.smallText}>{store.currentPractitioner?.website}</p>
        </button>
        */}
      </div>
    </div>

    <div className={styles.cancelWrapper}>
    <button 
        onClick={() => setIsOpen(false)}
        style={{
          background: 'none',
          color: '#000',
          fontSize: '17px',
          margin: '5px',
          borderRadius: '10px',
          border: 'none'
        }}
      >
        CANCEL
      </button>
      </div>

    </div>
  );
};

export default SendTab;
